import $ from 'jquery';
import { initializeFareAdapterElementForm } from './form_helpers';

const PAGE_CONTENT_SELECTOR = '[data-fac-element-page-content]';
const MODAL_SELECTOR = '[data-fac-element-modal]';
const MODAL_TITLE_SELECTOR = '[data-fac-element-modal-title]';
const MODAL_BODY_SELECTOR = '[data-fac-element-modal-body]';
const MODAL_TRIGGER_SELECTOR = '[data-fac-element-modal-link]';
const FORM_SELECTOR = '.js-fare-adapter-configuration-element-form';

const parseHTML = (html) => new window.DOMParser().parseFromString(html, 'text/html');

const fetchHTML = async (url, options = {}) => {
  const response = await fetch(url, {
    credentials: 'same-origin',
    headers: { Accept: 'text/html' },
    ...options
  });

  return {
    response,
    document: parseHTML(await response.text())
  };
};

const modalTitleFromDocument = (documentNode, fallbackTitle) => (
  documentNode.querySelector('.page-head-title')?.textContent?.trim() || fallbackTitle
);

const renderModalForm = (modal, documentNode, fallbackTitle) => {
  const form = documentNode.querySelector(FORM_SELECTOR);
  if (!form) return false;

  const title = modal.querySelector(MODAL_TITLE_SELECTOR);
  const body = modal.querySelector(MODAL_BODY_SELECTOR);

  title.textContent = modalTitleFromDocument(documentNode, fallbackTitle);
  body.innerHTML = form.outerHTML;

  const modalForm = body.querySelector(FORM_SELECTOR);
  if (modalForm) {
    initializeFareAdapterElementForm(modalForm);
  }

  return true;
};

const replacePageContent = (pageContent, documentNode) => {
  const updatedPageContent = documentNode.querySelector(PAGE_CONTENT_SELECTOR);
  if (!updatedPageContent) return false;

  const currentPageContent = pageContent;
  currentPageContent.innerHTML = updatedPageContent.innerHTML;
  return true;
};

const openModalWithLoadingState = (modal, titleText) => {
  const title = modal.querySelector(MODAL_TITLE_SELECTOR);
  const body = modal.querySelector(MODAL_BODY_SELECTOR);

  title.textContent = titleText;
  body.innerHTML = '<div class="text-center py-4"><i class="fa fa-spinner fa-pulse fa-fw"></i></div>';

  $(modal).modal('show');
};

const isModifiedClick = (event) => (
  event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
);

const setupFareAdapterElementModal = () => {
  const pageContent = document.querySelector(PAGE_CONTENT_SELECTOR);
  const modal = document.querySelector(MODAL_SELECTOR);

  if (!pageContent || !modal) return;

  $(modal).on('hidden.bs.modal', () => {
    const title = modal.querySelector(MODAL_TITLE_SELECTOR);
    const body = modal.querySelector(MODAL_BODY_SELECTOR);

    title.textContent = '';
    body.innerHTML = '';
  });

  pageContent.addEventListener('click', async (event) => {
    const link = event.target.closest(MODAL_TRIGGER_SELECTOR);
    if (!link || isModifiedClick(event)) return;

    event.preventDefault();
    openModalWithLoadingState(modal, link.textContent.trim());

    try {
      const { document: documentNode } = await fetchHTML(link.href);

      if (!renderModalForm(modal, documentNode, link.textContent.trim())) {
        window.location.assign(link.href);
      }
    } catch {
      window.location.assign(link.href);
    }
  });

  modal.addEventListener('submit', async (event) => {
    const form = event.target.closest(FORM_SELECTOR);
    if (!form) return;

    event.preventDefault();

    try {
      const { response, document: documentNode } = await fetchHTML(form.action, {
        body: new window.FormData(form),
        method: form.method.toUpperCase()
      });

      if (renderModalForm(modal, documentNode, modalTitleFromDocument(documentNode, ''))) {
        return;
      }

      if (replacePageContent(pageContent, documentNode)) {
        $(modal).modal('hide');
        return;
      }

      if (response.redirected) {
        window.location.assign(response.url);
        return;
      }

      form.submit();
    } catch {
      form.submit();
    }
  });
};

export { parseHTML, renderModalForm, replacePageContent, setupFareAdapterElementModal };
